import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { surveyApi } from '../../machine/api';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class NestedListApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id: questionId, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: questionId,
            data: answersActors.map((answerActor, idx) => {
                const { id, response } = answerActor.getSnapshot().context;
                const { extra, value } = response.getSnapshot().context;
                return {
                    bool: true,
                    text: value ? String(value) : null,
                    longtext: extra ? String(extra) : null,
                    int: idx + 1,
                    answer: id,
                };
            }),
            comment,
        };
    }

    public validate({ answersActors, nestedActor, params: { required } }: QuestionContext): boolean {
        if (!required) {
            return true;
        }

        if (surveyApi.isAnyNestedInProgress()) {
            return false;
        }

        const items = nestedActor.getSnapshot().context.nested;

        const firstNotAnswered = answersActors.find(
            (answerActor) => !answerActor.getSnapshot().context.response.getSnapshot().context.value,
        );

        if (firstNotAnswered) {
            const notAnsweredLevel = firstNotAnswered.getSnapshot().context.value[2];
            const levelItems = items[notAnsweredLevel];
            const levelEmpty = levelItems ? levelItems.length === 0 : true;

            if (levelEmpty) return true;
        }

        return answersActors.every(
            (answerActor) => !!answerActor.getSnapshot().context.response.getSnapshot().context.value,
        );
    }
}
